import React from 'react';
import { Loader2 } from 'lucide-react';

interface SelectLoaderProps {
  loading: boolean;
  children: React.ReactNode;
}

/** Wraps a <select> and shows a spinner over it while its options are loading. */
const SelectLoader: React.FC<SelectLoaderProps> = ({ loading, children }) => (
  <div className="relative" aria-busy={loading}>
    {children}
    {loading && (
      <span className="pointer-events-none absolute inset-y-0 right-8 flex items-center">
        <Loader2 className="h-4 w-4 animate-spin text-primary-600" aria-label="Loading options" />
      </span>
    )}
  </div>
);

export default SelectLoader;
